module.exports = "/_next/static/images/6c27d2d7e69037d197d2ba4b2dfe3b33-image-right-xs.jpg";